import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImagePreloadDirective } from './image-preload.directive';

@NgModule({
  exports: [ImagePreloadDirective],
  imports: [CommonModule, ImagePreloadDirective],
  providers: [],
})
export class ImagePreloadModule {}
